const hasPermission = (user, permissionToCheck) => {
  return user.permissions && user.permissions.includes(permissionToCheck);
};

const hasAnyPermissions = (user, permissionGroupToCheck) => {
  if (!permissionGroupToCheck) return false;
  return Object.values(permissionGroupToCheck).some(permission => hasPermission(user, permission));
};

const whichPermissions = (user, permissionGroupToCheck) => {
  if (!permissionGroupToCheck) return [];
  return Object.values(permissionGroupToCheck).filter(permission => hasPermission(user, permission));
};


/**
 * Client Republic has a user (David Charles) who will have early permission to a Metabase dashboard. No one else from any other client can currently have this permission.
 */
const checkHasRepublicPermission = (userId) => {
  const hasPermission = userId === window.env.REPUBLIC_USER_ID;
  return hasPermission;
};


const checkProtectedRoutePermission = (permission, auth) => {
  if (checkHasRepublicPermission(auth.user.id)) {
    return true;
  }

  if (permission && auth.user.permissions.indexOf(permission) === -1) {
    return false;
  }

  return true;
}

export {
  hasPermission,
  hasAnyPermissions,
  whichPermissions,
  checkProtectedRoutePermission,
  checkHasRepublicPermission
};